import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export const SortableGridItem = ({ id }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    fontSize: 10,
    padding: "4px 8px",
    margin: 4,
    background: isDragging ? "#d0ebff" : "#f8f9fa",
    border: "1px solid #ccc",
    borderRadius: 4,
    cursor: "grab",
    minWidth: 100,
    textAlign: "center",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {id}
    </div>
  );
};
